import { isBootstrapHttpError } from "../environments/primary/bootstrapError";
import { CmmdApiError } from "../environments/cmmdApi/transport";

/**
 * Detects whether an error represents an authentication failure on the
 * desktop-cloud bearer session path.
 *
 * Recognizes:
 * - BootstrapHttpError with status 401 (primary auth.ts)
 * - RemoteEnvironmentAuthHttpError with status 401 (remote/api.ts, not exported
 *   so matched structurally)
 * - CmmdApiError with kind "auth" (cmmdApi transport)
 */
export function isCloudBearerAuthFailure(error: unknown): boolean {
  if (error === null || error === undefined) return false;
  if (typeof error !== "object") return false;

  // BootstrapHttpError { _tag: "BootstrapHttpError", status: 401 }
  if (isBootstrapHttpError(error) && error.status === 401) {
    return true;
  }

  // RemoteEnvironmentAuthHttpError (not exported, match structurally)
  if (
    error instanceof Error &&
    error.name === "RemoteEnvironmentAuthHttpError" &&
    "status" in error &&
    (error as { status: unknown }).status === 401
  ) {
    return true;
  }

  // CmmdApiError { kind: "auth" }
  if (error instanceof CmmdApiError && error.kind === "auth") {
    return true;
  }

  return false;
}
